export default __webpack_public_path__ + "static/media/topaz.f9f38dac.jpg";